module.exports = __webpack_public_path__ + "img/ward1.127dc347.svg";